import React from 'react';

const NotFound = () => {
  /* eslint-disable */
  return (
    <svg
      width="50px"
      height="56px"
      viewBox="0 0 50 56"
      version="1.1"
      xmlns="http://www.w3.org/1999/xlink"
    >
      <g id="Pedidos" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Lista-de-pedidos---Nenhum-Resultado" transform="translate(-141.000000, -556.000000)">
          <g id="Group-4" transform="translate(-1.000000, 424.000000)">
            <g id="Nenhum_resultado" transform="translate(84.000000, 129.000000)">
              <g id="Group-43" transform="translate(60.000000, 0.000000)">
                <path
                  d="M32,27 C32,35.836 24.836,43 16,43 C7.164,43 0,35.836 0,27 C0,18.164 7.164,11 16,11 C24.836,11 32,18.164 32,27 L32,27 Z"
                  id="Stroke-1410"
                  stroke="#D1D1D1"
                  strokeWidth="3"
                  strokeLinejoin="round"
                />
                <path
                  d="M27.334,38.334 L46,57"
                  id="Stroke-1411"
                  stroke="#D1D1D1"
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <g
                  id="Group-5"
                  transform="translate(27.556349, 15.556349) rotate(-45.000000) translate(-27.556349, -15.556349) translate(16.556349, 4.556349)"
                >
                  <circle
                    id="Oval-2"
                    stroke="#FBFBFB"
                    strokeWidth="3"
                    fill="#D1D1D1"
                    cx="10.7027958"
                    cy="10.7027958"
                    r="10.7027958"
                  />
                  <path
                    d="M9.69097687,9.69097687 L9.69097687,5.98097412 C9.69097687,5.42216196 10.1439836,4.96915519 10.7027958,4.96915519 C11.261608,4.96915519 11.7146147,5.42216196 11.7146147,5.98097412 L11.7146147,9.69097687 L15.4246175,9.69097687 C15.9834296,9.69097687 16.4364364,10.1439836 16.4364364,10.7027958 C16.4364364,11.261608 15.9834296,11.7146147 15.4246175,11.7146147 L11.7146147,11.7146147 L11.7146147,15.4246175 C11.7146147,15.9834296 11.261608,16.4364364 10.7027958,16.4364364 C10.1439836,16.4364364 9.69097687,15.9834296 9.69097687,15.4246175 L9.69097687,11.7146147 L5.98097412,11.7146147 C5.42216196,11.7146147 4.96915519,11.261608 4.96915519,10.7027958 C4.96915519,10.1439836 5.42216196,9.69097687 5.98097412,9.69097687 L9.69097687,9.69097687 Z"
                    id="Combined-Shape"
                    fill="#FBFBFB"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
  /* eslint-enable */
};

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/Icons/NotFound.js